import React, { useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RemotePodLoader from "../components/recording/RemotePodLoader";

const loadRecordingTidalBreathing = () => import("recordingTidalBreathing/App");

const DEMO_RECORDING_DURATIONS_SECONDS = new Set([15, 30, 60]);

function getRecordingDurationSecondsOverride({
  search,
  fallback,
}) {
  const params = new URLSearchParams(search);
  const rawValue = params.get("recordingDurationSeconds");
  const parsedValue = Number(rawValue);

  if (
    !Number.isInteger(parsedValue) ||
    !DEMO_RECORDING_DURATIONS_SECONDS.has(parsedValue)
  ) {
    return fallback;
  }

  return parsedValue;
}

export default function RecordingTidalBreathingRouter(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const didRedirectRef = useRef(false);
  const basePath = props.basePath || "/recording/tidal-breathing";
  const recordingDurationSeconds = getRecordingDurationSecondsOverride({
    search: location.search,
    fallback: props.recordingDurationSeconds,
  });

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // Optional: route away from /recording/spirometry/camera once upload begins
      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate(basePath, { replace: true });
      }
    },
    [basePath, navigate, props],
  );

  return (
    <RemotePodLoader
      load={loadRecordingTidalBreathing}
      componentProps={{
        ...props,
        recordingDurationSeconds,
        onUploadStatus: handleUploadStatus,
        onUploadProgress: props.onUploadProgress,
      }}
    />
  );
}
